"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBarLanguages = TopBarLanguages;
var _react = _interopRequireDefault(require("react"));
var _Dropdown = require("b2b-components/theme/components/Dropdown");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
function TopBarLanguages(_ref) {
  var _languages$find;
  var activeLanguage = _ref.activeLanguage,
    languages = _ref.languages,
    onLanguageChange = _ref.onLanguageChange,
    isDropdown = _ref.isDropdown;
  if (!Array.isArray(languages) || !languages.length) {
    return null;
  }
  var handleLanguageChange = function handleLanguageChange(language) {
    return function (e) {
      onLanguageChange(language);
      e.preventDefault();
    };
  };
  var languagesDropdownList = languages.map(function (_ref2) {
    var label = _ref2.label,
      code = _ref2.code;
    return {
      title: label,
      language: code
    };
  });
  var dropdownLinks = languagesDropdownList.map(function (_ref3) {
    var title = _ref3.title,
      language = _ref3.language;
    return {
      onClick: function onClick() {
        return onLanguageChange(language);
      },
      title: title
    };
  });
  var linkLabel = /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Dropdown-Container"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.globe,
    size: _Icon.ICON_SIZE.small
  }), (_languages$find = languages.find(function (lang) {
    return lang.code === activeLanguage;
  })) === null || _languages$find === void 0 ? void 0 : _languages$find.label);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-TopBar-Section cds-TopBar-Section--LangSwitch"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-List cds-List--Unstyled cds-List--Inline"
  }, isDropdown ? /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown, {
    links: dropdownLinks,
    isHoverable: true,
    className: "cds-TopBar-DropDropdown",
    tooltipWrapperClassName: "cds-TopBar-Tooltip",
    togglerProps: {
      label: linkLabel,
      className: 'cds-TopBar-Dashboard-Toggler'
    }
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, languages.map(function (language) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: language.label
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#",
      className: (0, _classnames["default"])('cds-TopBar-Link', {
        'cds-TopBar-Link--Active': activeLanguage === language.code
      }),
      onClick: handleLanguageChange(language.code)
    }, language.label));
  }))));
}